import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImagestack = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.1267 9.12494H11.1267V10.1249V29.4025V30.4025H12.1267H15.4258L21.2951 33.5872L21.2956 33.5875L24.5272 35.3506L25.405 35.8295L25.8851 34.9523L28.3752 30.4025H28.3858H29.3858V29.4025V28.5559L34.3489 19.4875L34.8289 18.6103L33.9511 18.1314L31.401 16.7401L29.3858 15.6406V10.1249V9.12494H28.3858H12.1267ZM29.3858 17.9189V24.3902L32.1132 19.4069L30.4408 18.4944L29.3858 17.9189ZM27.3858 15.7963V11.1249H13.1267V23.9455L16.5003 20.5771L17.2069 19.8717L17.9134 20.5771L20.2555 22.9155L27.3858 15.7963ZM27.3858 18.6225V28.0445L27.1899 28.4025H13.1267V26.7717L17.2069 22.6979L21.5813 27.0655L22.9944 25.6502L21.6708 24.3286L27.3858 18.6225ZM26.0953 30.4025H19.6192L22.2532 31.8317L22.2552 31.8328L24.6095 33.1173L26.0953 30.4025Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M19.2392 18.241C20.3617 18.241 21.2716 17.3325 21.2716 16.2118C21.2716 15.0911 20.3617 14.1826 19.2392 14.1826C18.1168 14.1826 17.2068 15.0911 17.2068 16.2118C17.2068 17.3325 18.1168 18.241 19.2392 18.241Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10
	})]
});
const ForwardRef = forwardRef(SvgImagestack);
export default ForwardRef;
